/****************************************************
 * Module Name:  SellToOutsourceModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import { Box, Button } from "@mui/material";
import SaveIcon from '@mui/icons-material/Save';
import logo from "../../images/pansuriya.jpg";
import Constants from "../../utility/constants";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import CustomerFTPsettingsProxy from "../../utility/proxy/manager/customerFTPsettingsProxy";


export default function SellToOutsourceModal({
    show,
    loading,
    setShow,
    stoneId,
    discount,
    stoneData,
    handleSave,
    ppcDiscount,
    handleValidation,

}) {
    const [showError, setShowError] = useState(false);
    const [newFTPCustomer, setNewFTPCustomer] = useState('');
    const [customerFTPOptions, setCustomerFTPOptions] = useState([]);

    useEffect(() => {
        fetchCustomerFTPData();
    }, [])

    const fetchCustomerFTPData = () => {
        CustomerFTPsettingsProxy.getAllCustomerFTPDetailsMini((res) => {
            setAllCustomerFTPData(res);
        })
    }

    const setAllCustomerFTPData = (res) => {
        if (res) {
            let optionsArray = [];
            res.map((data) => {
                let option = { value: data.customerid, label: data.customerid + " | " + data.customerusername + " | " + data.customerfirst_name }
                optionsArray.push(option);

                return true;
            })
            setCustomerFTPOptions(optionsArray)
            setNewFTPCustomer(
                newFTPCustomer === "" && optionsArray.length > 0
                    ? optionsArray[0] : newFTPCustomer
            )
        }
    }

    const saveHandler = () => {
        let tempSellToOutsourceStone = [];
        // let tempDiscount = Object.keys(discount);
        stoneData.map((stone, index) => {
            if (stoneId.includes(stone.stoneid)) {
                let data = {
                    userid: newFTPCustomer.value,
                    stoneid: stone.stoneid,
                    createdby: Constants.loggedInUser.id,
                    createdat: stone.createdat,
                    discount: discount[stone.stoneid] ? discount[stone.stoneid] : "",
                    ppcdiscount: ppcDiscount ? ppcDiscount[stone.stoneid] : "",
                };
                tempSellToOutsourceStone.push(data);
            }
            return true;
        })

        if (handleSave) {
            if (handleValidation) {
                if (handleValidation(tempSellToOutsourceStone)) {
                    handleSave(tempSellToOutsourceStone);
                } else {
                    setShowError(true);
                }
            } else {
                handleSave(tempSellToOutsourceStone);
            }
        }
    };

    const handleClose = () => {
        setShow(false);
    };

    const closeErrorDialog = () => {
        setShowError(false);
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={true}
            customer="lg"
            centered
            enforceFocus={false}
        >
            <CommonSnackbar
                show={showError}
                message={
                    <Box>
                        Stone Sell To OutSource Failed
                        <br /> Please enter correct data
                    </Box>
                }
                variant={"error"}
                autoHide={false}
                handleClose={closeErrorDialog}
                title="Validation Failure"
            />
            <Modal.Header closeButton>
                <Modal.Title>
                    <img
                        src={logo}
                        height="40pt"
                        width="40pt"
                        alt={Constants.COMPANY_SITE}
                    />
                    &nbsp;&nbsp;Sell To OutSource
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Box sx={{ display: "flex", flex: 1, gap: "20px" }}>
                    <Form.Label className="mt-2">Customer FTP : </Form.Label>
                    <Select menuPlacement="auto"
                        blurInputOnSelect={false}
                        className="basic-single"
                        classNamePrefix="select"
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        value={newFTPCustomer}
                        isSearchable={true}
                        name="Customer"
                        menuPortalTarget={document.body}
                        styles={Constants.Styles}
                        options={customerFTPOptions}
                        onChange={(selectedOption) => setNewFTPCustomer(selectedOption)}
                    />
                </Box>
            </Modal.Body>
            <Modal.Footer>
                <LoadingButton
                    loading={loading}
                    loadingPosition="start"
                    startIcon={<SaveIcon />}
                    variant="contained"
                    color="success"
                    onClick={saveHandler}
                    type="Submit"
                    sx={{ mr: 3 }}
                    disabled={!newFTPCustomer}
                >
                    Save
                </LoadingButton>
                <Button
                    variant="contained"
                    color="error"
                    onClick={handleClose}
                    sx={{ mr: 2 }}
                    disabled={loading}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}